module.exports = __webpack_public_path__ + "img/ddzg-bg.6bfd5b28.jpg";